module.exports = __webpack_public_path__ + "img/stock6.f1c1f644.png";